<!-- 数据字典管理 -->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{}'
    :option="{}"
    :colObj='{
      opId:"106",
      col:[]
    }'
  >
  </Table>
</div>
</template>
<script>
import Table from '@/components/table/dataTablec';
export default {
  components: {
    Table
  },
  data() {},
  methods: {
    // 字典详情
    dictDetailRowClick(btn,row){
      this.$router.push({
        path:'/system/dataDictionarySon',
        query:{
          runId:this.$route.query.runId,
          DICT_ID:row.ID,
          sname:row.DICT_DESC,
        }
      })
    },
  },
  created(){},
  computed: {},
};
</script>
<style lang="scss" scoped>
</style>

